var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Groupon.Widgets.BackToTopButton = (function() {
  function BackToTopButton() {
    this.bind = bind(this.bind, this);
    this.showOrHide = bind(this.showOrHide, this);
    this.requestTick = bind(this.requestTick, this);
    var fn;
    if (!(this.$back2top = $('#ls-back-to-top')).length) {
      return;
    }
    this.offset = $('.header-v2 header.header').height() * 1.5;
    this.visible = false;
    if (window.requestAnimationFrame) {
      fn = this.requestTick;
    } else {
      fn = this.showOrHide;
    }
    $(window).on('scroll', _.throttle(fn, 1000));
    this.bind();
  }

  BackToTopButton.prototype.requestTick = function() {
    return window.requestAnimationFrame(this.showOrHide);
  };

  BackToTopButton.prototype.showOrHide = function() {
    var threshold, y;
    y = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    threshold = y > this.offset;
    if (threshold && !this.visible) {
      this.$back2top.css({
        'z-index': 200
      });
      this.$back2top.addClass('ls-back-to-top-visible').attr('aria-hidden', 'false');
      return this.visible = true;
    } else if (this.visible && !threshold) {
      this.$back2top.attr('aria-hidden', 'true').removeClass('ls-back-to-top-visible');
      return this.visible = false;
    }
  };

  BackToTopButton.prototype.bind = function() {
    this.$back2top.on('click', (function(_this) {
      return function() {
        return $('body, html').animate({
          scrollTop: 0
        }, 500, function() {
          return _this.$back2top.attr('aria-hidden', 'true');
        });
      };
    })(this));
    return this.$back2top.on('transitionend', (function(_this) {
      return function() {
        if (_this.$back2top.css('opacity') === '0') {
          return _this.$back2top.css({
            'z-index': -1
          });
        }
      };
    })(this));
  };

  return BackToTopButton;

})();

//# sourceMappingURL=data:application/json;base64,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
